var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Groupon.Widgets.BackToTopButton = (function() {
  function BackToTopButton() {
    this.bind = bind(this.bind, this);
    this.showOrHide = bind(this.showOrHide, this);
    this.requestTick = bind(this.requestTick, this);
    var fn;
    if (!(this.$back2top = $('#ls-back-to-top')).length) {
      return;
    }
    this.offset = $('.header-v2 header.header').height() * 1.5;
    this.visible = false;
    if (window.requestAnimationFrame) {
      fn = this.requestTick;
    } else {
      fn = this.showOrHide;
    }
    $(window).on('scroll', _.throttle(fn, 1000));
    this.bind();
  }

  BackToTopButton.prototype.requestTick = function() {
    return window.requestAnimationFrame(this.showOrHide);
  };

  BackToTopButton.prototype.showOrHide = function() {
    var threshold, y;
    y = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    threshold = y > this.offset;
    if (threshold && !this.visible) {
      this.$back2top.css({
        'z-index': 200
      });
      this.$back2top.addClass('ls-back-to-top-visible').attr('aria-hidden', 'false');
      return this.visible = true;
    } else if (this.visible && !threshold) {
      this.$back2top.attr('aria-hidden', 'true').removeClass('ls-back-to-top-visible');
      return this.visible = false;
    }
  };

  BackToTopButton.prototype.bind = function() {
    this.$back2top.on('click', (function(_this) {
      return function() {
        return $('body, html').animate({
          scrollTop: 0
        }, 500, function() {
          return _this.$back2top.attr('aria-hidden', 'true');
        });
      };
    })(this));
    return this.$back2top.on('transitionend', (function(_this) {
      return function() {
        if (_this.$back2top.css('opacity') === '0') {
          return _this.$back2top.css({
            'z-index': -1
          });
        }
      };
    })(this));
  };

  return BackToTopButton;

})();

//# sourceMappingURL=data:application/json;base64,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
